var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Groupon.Widgets.BackToTopButton = (function() {
  function BackToTopButton() {
    this.bind = bind(this.bind, this);
    this.showOrHide = bind(this.showOrHide, this);
    this.requestTick = bind(this.requestTick, this);
    var fn;
    if (!(this.$back2top = $('#ls-back-to-top')).length) {
      return;
    }
    this.offset = $('.header-v2 header.header').height() * 1.5;
    this.visible = false;
    if (window.requestAnimationFrame) {
      fn = this.requestTick;
    } else {
      fn = this.showOrHide;
    }
    $(window).on('scroll', _.throttle(fn, 1000));
    this.bind();
  }

  BackToTopButton.prototype.requestTick = function() {
    return window.requestAnimationFrame(this.showOrHide);
  };

  BackToTopButton.prototype.showOrHide = function() {
    var threshold, y;
    y = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    threshold = y > this.offset;
    if (threshold && !this.visible) {
      this.$back2top.css({
        'z-index': 200
      });
      this.$back2top.addClass('ls-back-to-top-visible').attr('aria-hidden', 'false');
      return this.visible = true;
    } else if (this.visible && !threshold) {
      this.$back2top.attr('aria-hidden', 'true').removeClass('ls-back-to-top-visible');
      return this.visible = false;
    }
  };

  BackToTopButton.prototype.bind = function() {
    this.$back2top.on('click', (function(_this) {
      return function() {
        return $('body, html').animate({
          scrollTop: 0
        }, 500, function() {
          return _this.$back2top.attr('aria-hidden', 'true');
        });
      };
    })(this));
    return this.$back2top.on('transitionend', (function(_this) {
      return function() {
        if (_this.$back2top.css('opacity') === '0') {
          return _this.$back2top.css({
            'z-index': -1
          });
        }
      };
    })(this));
  };

  return BackToTopButton;

})();

//# sourceMappingURL=data:application/json;base64,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
